import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import StatusDropdown from './StatusDropdown';

const StatusFilter = ({
  options,
  dropdownLabel,
  ...props
}: Omit<DropDownFilterProps, 'children'> & {
  options: Dictionary<string>;
  dropdownLabel?: string;
}) => {
  return (
    <DropDownFilter {...props}>
      <StatusDropdown options={options} dropdownLabel={dropdownLabel} />
    </DropDownFilter>
  );
};

export default StatusFilter;
